<div
  class="tt-spinner"
  [ngClass]="{
    'tt-spinner--sm': size === 'sm',
    'tt-spinner--md': size === 'md',
    'tt-spinner--lg': size === 'lg',
    'tt-spinner--xl': size === 'xl'
  }"
  role="status"
  [attr.aria-label]="ariaLabel"
>
  <span class="sr-only">{{ ariaLabel }}</span>
</div>
